import React from "react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

const options = {
  autoClose: 6000,
  pauseOnHover: true,
  hideProgressBar: true,
  type: toast.TYPE.INFO,
  position: toast.POSITION.TOP_CENTER
};

class Mensagem extends React.Component {
  static propTypes = {
    mensagem: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired
  };

  render() {
    const { mensagem } = this.props;
    if (!Array.isArray(mensagem)) {
      return mensagem;
    }

    return (
      <div>
        <ul className="list-unstyled">
          {mensagem.map((mensagem, i) => (
            <li key={i}>{mensagem}</li>
          ))}
        </ul>
      </div>
    );
  }
}

export const info = mensagem => {
  toast.info(<Mensagem mensagem={mensagem} />, options);
};

export const success = mensagem => {
  toast.success(<Mensagem mensagem={mensagem} />, options);
};

export const error = mensagem => {
  toast.error(<Mensagem mensagem={mensagem} />, options);
};

export const warn = mensagem => {
  toast.warn(<Mensagem mensagem={mensagem} />, options);
};



// WEBPACK FOOTER //
// ./src/utils/MensagemUtil.js